function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.998 2.998h5.704a2.852 2.852 0 010 5.703H2.998",
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.25,
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.998,
  cy: 5.85,
  r: 2.852,
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.25,
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgInStockSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref, _ref2);
}

export default SvgInStockSwitch;